/**
 * Source: https://play.tailwindcss.com/sO4EMCZ54A
 */

const dsIcon = (theme) => ({
  fontFamily: theme("fontFamily.icons"),
});
module.exports = (theme) => ({
  /* Open and close nav icons */
  [`
   .navbar .accordion-button::before`]: {
    ...dsIcon(theme),
    "@apply ds-mx-xs ds-text-base": true,
  },
  ".navbar .accordion-button::before": {
    content: "'\\e981'",
  },
  ".navbar .accordion-button:checked::before": {
    content: '"\\e98c"',
  },
  ".navbar": {
    "@apply ds-sticky ds-flex ds-h-3xl ds-items-center ds-justify-between ds-bg-primary-white md:ds-px-2xl ds-z-50": true,
  },
  ".navbar .logo": {
    "@apply ds-mx-auto md:ds-mx-0 md:ds-w-auto": true,
  },
  ".navbar .logo img": {
    "@apply ds-min-w-[8rem] xs:ds-min-w-[12rem]": true,
  },
  /* Hiding logo text */
  ".navbar .logo span": {
    "@apply ds-sr-only": true,
  },
  ".navbar .responsive-visibility": {
    "@apply ds-hidden md:ds-flex": true,
  },
  ".navbar a": {
    "@apply ds-text-base": true,
  },
  ".navbar .ds-link::before": {
    "@apply ds-text-xl": true,
  },
  ".navbar .language-selector": {
    "@apply ds-flex ds-items-center md:ds-mr-lg": true,
  },
  ".navbar .menu": {
    "@apply ds-absolute ds-right-sm ds-flex md:ds-right-3xl": true,
  },
  ".navbar .language-selector > nav": {
    "@apply ds-absolute md:ds-right-[9.1rem] md:ds-top-[2.1rem] ds-right-0 ds-top-[1.9rem] ds-min-w-[12rem] ds-bg-background-blue": true,
  },
  ".navbar .language-selector > nav > a": {
    "@apply ds-block ds-p-xs": true,
  },
  ".navbar .language-selector > nav > a:hover": {
    "@apply ds-bg-primary-blue ds-text-primary-white": true,
  },
  ".navbar .language-selector > input": {
    "@apply ds-cursor-pointer ds-appearance-none ds-text-3xl hover:ds-text-primary-blue": true,
  },
  ".navbar .language-selector > input ~ nav": {
    "@apply ds-hidden": true,
  },
  ".navbar .language-selector > input:checked ~ nav": {
    "@apply ds-block": true,
  },
  ".navbar .language-selector > input:checked": {
    "@apply ds-bg-background-blue": true,
  },
  ".navbar .language-selector > p": {
    "@apply ds-px-xs": true,
  },
  ".icons-globe-1": {
    "@apply ds-h-[1.3rem] ds-w-[1.3rem] xs:ds-h-[1.75rem] ds-w-[1.75rem]": true,
  },
});
